import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { hmrBootstrap } from 'hmr';

// Load CKEditor once and expose constructor to all MFEs (avoids ckeditor-duplicated-modules when navigating app1 ↔ app2)
const ckeditorUrl = (window as any).__CKEDITOR_DECOUPLED_URL__;
if (ckeditorUrl) {
  import(/* webpackIgnore: true */ ckeditorUrl).then((m: any) => {
    (window as any).__CKEDITOR_DECOUPLED_EDITOR__ = m.default;
  });
}

if ( environment.production )
{
    enableProdMode();
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], });

if (environment.hmr) {
  // Webpack-based HMR (@angularclass/hmr) when module.hot exists (legacy browser builder).
  // Application builder (esbuild) uses CLI HMR without module.hot — bootstrap normally.
  const hot = typeof module !== 'undefined' && (module as unknown as { hot?: unknown }).hot;
  if (hot) {
    hmrBootstrap(module, bootstrap);
  } else {
    bootstrap().catch((err) => console.error(err));
  }
} else {
  bootstrap().catch((err) => console.error(err));
}
